import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export interface SiteTypeItem {
    id: string;
    tenantId: string | null;
    name: string;
    colorHex: string;
    isActive: boolean;
    isDeleted: boolean;
}

export interface SiteTypeCreatePayload {
    name: string;
    colorHex: string;
    tenantId?: string | null; // Omit for tenant-specific, set to null for global types (SuperAdmin only)
}

export interface SiteTypeUpdatePayload {
    name: string;
    colorHex: string;
    isActive?: boolean;
}

export const getAllSiteTypes = async (): Promise<SiteTypeItem[]> => {
    try {
        const response = await api.get(url.GET_SITE_TYPES) as unknown as SiteTypeItem[] | { items?: SiteTypeItem[]; result?: SiteTypeItem[] };
        
        // Handle different response structures
        if (Array.isArray(response)) {
            return response;
        }
        
        // Handle wrapped responses
        if (response && typeof response === 'object') {
            if (Array.isArray((response as any).items)) {
                return (response as any).items;
            }
            if (Array.isArray((response as any).result)) {
                return (response as any).result;
            }
        }
        
        console.warn("Unexpected response structure from site types API:", response);
        return [];
    } catch (error) {
        console.error("Error fetching site types:", error);
        return [];
    }
};

export const createSiteType = (
    data: SiteTypeCreatePayload
): Promise<SiteTypeItem> => {
    return api.create(url.ADD_NEW_SITE_TYPE, data) as unknown as Promise<SiteTypeItem>;
};

export const updateSiteType = (
    id: string,
    data: SiteTypeUpdatePayload
): Promise<SiteTypeItem> => {
    return api.put(url.UPDATE_SITE_TYPE + "/" + id, data) as unknown as Promise<SiteTypeItem>;
};

export const deleteSiteType = (id: string): Promise<void> => {
    return api.delete(url.DELETE_SITE_TYPE + "/" + id) as unknown as Promise<void>;
};
